import {
  Component,
  inject,
  Input,
  OnInit,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { GoldenProfile } from '@models/GoldenProfile';
import { SourceCrossReference } from '@models/CrossReference';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { CommonService } from '@services/common.service';
import { SearchProfileService } from '@services/search-profile.service';
import { SourceData } from '@models/SourceData';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SourcePopupComponent } from '../source-popup/source-popup.component';
import { ColumnSelectionPopupComponent } from '../column-selection-popup/column-selection-popup.component';
import { ColumnsModel, StandardAddress } from '@models/ColumnsModel';
import { Source } from '@models/Source';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { AppConstants } from '@constants/app.constant';
import { ExportDateResponse, ExportExpireDate } from '@models/ExportExipreDate';
import { DisplayColNamePipe } from 'src/app/pipes/display-col-name';
import { Obj } from '@popperjs/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BulkSearchService } from '@services/BulkSearchService';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { exportToExcelMultipleSheets } from '@services/ExportTableData';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-result-profile',
  templateUrl: './result-profile.component.html',
  styleUrl: './result-profile.component.scss',
  standalone: true,
  providers: [DisplayColNamePipe],
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
  ],
})
export class ResultProfileComponent implements OnInit, OnDestroy {
  selectedKey!: number;
  private router = inject(Router);
  private readonly displayColName = inject(DisplayColNamePipe);
  bulkSearchService = inject(BulkSearchService);
  private readonly toastr = inject(ToastrService);
  commonService = inject(CommonService);
  private readonly searchProfileService = inject(SearchProfileService);
  private readonly modalService = inject(NgbModal);
  readonly crMandatoryCols: string[] = ['rcm_id', 'source', 'source_id'];
  readonly gpMandatoryCols: string[] = ['rcm_id', 'name'];
  readonly constants = AppConstants;
  private route = inject(ActivatedRoute);
  columnName: string[] = [];
  isDeaExpiredExist = false;
  hasExpPrefCol = false;
  @Input() sourceList: Source[] = [];
  distinctSource: string[] = [];
  sADisplayedColumns: string[] = [
    'source_id',
    'address_line_1',
    'std_address_line_1',
  ];
  @Input() columnModal: ColumnsModel[] = [];
  @Input() colPref = {
    cross_reference_columns: '',
    golden_profile_columns: '',
  };
  @ViewChild('modalContent') modalTemplateRef!: TemplateRef<unknown>;
  standardData: {
    address_line_1: string;
    address_line_2: null;
    std_address_line_1: string;
    std_address_line_2: null;
    source_id: string;
  }[] = [];

  @ViewChild('sortGP') sortGP!: MatSort;
  @ViewChild('sortCR') sortCR!: MatSort;

  private timeoutIds: any[] = [];
  // for Golden Profile
  @ViewChild('profilePaginator') paginator!: MatPaginator;
  @ViewChild('profilePaginator') set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setupPaginator();
  }
  goldenProfilesMp!: MatTableDataSource<GoldenProfile>;
  totalItems = 0; // Total number of items (this can be fetched from an API)
  pageSize = 5;
  page = 0;
  selectedGoldenProfile: GoldenProfile | null = null;

  // for Cross Reference
  @ViewChild('sourcePaginator') rPaginator!: MatPaginator;
  @ViewChild('sourcePaginator') set rMatPaginator(mpr: MatPaginator) {
    this.rPaginator = mpr;
    this.setupPaginatorCR();
  }
  sourceCrossReferencesMp!: MatTableDataSource<SourceCrossReference>;
  rTotalItems = 0; // Total number of items (this can be fetched from an API)
  rPageSize = 10;
  rPage = 0;

  filteredSourceCrossReferencesFiltered: SourceCrossReference[] = [];
  @Input() goldenProfiles: GoldenProfile[] = [];
  @Input() sourceCrossReferences: SourceCrossReference[] = [];

  @Input() searchParams: { display: string; value: string }[] = [];
  displayedColumns: string[] = [
    'rcm_id',
    'name',
    'type',
    'address_line_1',
    'city',
    'state',
    'zip',
    'usps_status',
    'dea_num',
    'hin_no',
    'id_340b',
    'npi',
    'sln',
    'tddd_oh',
    'res_com',
  ];
  sourceDisplayedColumns: string[] = [
    'rcm_id',
    'source',
    'source_id',
    'name',
    'type',
    'address_line_1',
    'address_line_2',
    'city',
    'state',
    'zip',
    'usps_status',
    'dea_num',
    'hin_no',
    'id_340b',
    'npi',
    'sln',
    'tddd_oh',
    'gln_id',
    'sap_id',
    'rmus_id',
    'shift_id',
    'cot_desc',
  ];

  sourceDisplayedColumnsAll: string[] = [
    'rcm_id',
    'source',
    'source_id',
    'name',
    'address_line_1',
    'address_line_2',
    'city',
    'state',
    'zip',
    'usps_status',
    'dea_num',
    'hin_no',
    'id_340b',
    'npi',
    'sln',
    'tddd_oh',
    'gln_id',
    'cot_desc',
  ];

  ngOnInit(): void {
    if (!history.state || Object.keys(history.state).length === 0) {
    this.router.navigate(['/main/crt/search']);
    return;
  }
    this.setBulkSearchResponse();
    this.route.paramMap.subscribe(params => {
  const rcmId = params.get('rcmId');

  if (rcmId) {
    this.loadProfile(rcmId);
  }
});
    this.setDisplayColumns();
    this.filteredSourceCrossReferencesFiltered = this.sourceCrossReferences;

    // for Golden Profile
    this.goldenProfilesMp = new MatTableDataSource<GoldenProfile>(
      this.goldenProfiles
    );
    this.totalItems = this.goldenProfiles.length;
    if (this.paginator) {
      this.goldenProfilesMp.paginator = this.paginator;
    }

    // for Cross Reference
    this.sourceCrossReferencesMp = new MatTableDataSource<SourceCrossReference>(
      this.filteredSourceCrossReferencesFiltered
    );
    this.rTotalItems = this.filteredSourceCrossReferencesFiltered.length;
    if (this.rPaginator) {
      this.sourceCrossReferencesMp.paginator = this.rPaginator;
    }
    this.setDistinctSource();
    this.checkExpiredDEAExist();
    this.deferSortSetup();
    const selectedRcmId =
  this.commonService.selectedResultProfileRcmId;

if (selectedRcmId) {

  setTimeout(() => {

    const matchedProfile =
      this.goldenProfiles.find(
        gp => gp.rcm_id == selectedRcmId
      );

    if (matchedProfile) {

      this.selectProfile(matchedProfile);

      setTimeout(() => {

        const element =
          document.querySelector('.ptrow-active');

        element?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

      }, 100);
    }

    this.commonService.selectedResultProfileRcmId = '';

  }, 300);
}
  }

  ngOnDestroy(): void {
    this.timeoutIds.forEach(id => clearTimeout(id));
  }

  private deferSortSetup(): void {
    // Defer sort setup to ensure ViewChilds are available
    this.timeoutIds.push(setTimeout(() => {
      this.setupSortGP();
      this.setupSortCR();
    }, 0));
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.sourceDisplayedColumns,
      event.previousIndex,
      event.currentIndex
    );
  }

  selectProfile(row: GoldenProfile) {
    if (this.selectedGoldenProfile) {
      if (this.selectedGoldenProfile.rcm_id == row.rcm_id) {
        this.filteredSourceCrossReferencesFiltered = this.sourceCrossReferences;
        this.selectedGoldenProfile = null;
        this.setDistinctSource();
        this.toggleAllSelection();
        this.setupSortCR();
        return;
      }
    }
    this.selectedGoldenProfile = row;
    this.filteredSourceCrossReferencesFiltered =
      this.sourceCrossReferences.filter((scr: SourceCrossReference) => {
        return scr.rcm_id == row.rcm_id;
      });
    this.setDistinctSource();
    this.toggleAllSelection();
    this.setupSortCR();
  }
  setUpCrossRefernce() {
    // for Cross Reference
    this.sourceCrossReferencesMp = new MatTableDataSource<SourceCrossReference>(
      this.filteredSourceCrossReferencesFiltered
    );
    this.rTotalItems = this.filteredSourceCrossReferencesFiltered.length;
    this.sourceCrossReferencesMp.paginator = this.rPaginator;
    this.page = 0;
    //
  }

  //setup Paginator for Golden Profile
  setupPaginator() {
    if (this.paginator) {
      this.goldenProfilesMp.paginator = this.paginator;
      this.paginator.pageIndex = this.page;
      this.paginator.pageSize = this.pageSize;
      this.paginator.length = this.totalItems;
    }
  }
  // Method to handle page change for Golden Profile
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.page = event.pageIndex;
  }

  //setup Paginator for Cross Refrence
  setupPaginatorCR() {
    if (this.rPaginator) {
      this.sourceCrossReferencesMp.paginator = this.rPaginator;
      this.rPaginator.pageIndex = this.rPage;
      this.rPaginator.pageSize = this.rPageSize;
      this.rPaginator.length = this.rTotalItems;
    }
  }
  // Method to handle page change for Cross Refrence
  onPageChangeCR(event: PageEvent): void {
    this.rPageSize = event.pageSize;
    this.rPage = event.pageIndex;
  }
  setupSortGP() {
    if (this.sortGP) {
      this.sortGP.active = 'match_rank';
      this.sortGP.direction = 'asc';
      this.goldenProfilesMp.sort = this.sortGP;
      this.sortGP.sortChange.emit({
        active: this.sortGP.active,
        direction: this.sortGP.direction,
      });
    }
  }
  setupSortCR() {
    if (this.sortCR) {
      this.sortCR.active = 'match_rank';
      this.sortCR.direction = 'asc';
      this.sourceCrossReferencesMp.sort = this.sortCR;
      this.sortCR.sortChange.emit({
        active: this.sortCR.active,
        direction: this.sortCR.direction,
      });
    }
  }
openAffiliationView() {
  if (!this.selectedGoldenProfile) return;

  this.commonService.setShowLoader(true);

  // ✅ save selected profile
  this.commonService.selectedAffiliationProfile =
    this.selectedGoldenProfile;

  // ✅ store selected row to restore later
  this.commonService.selectedResultProfileRcmId =
    this.selectedGoldenProfile.rcm_id;

  setTimeout(() => {
    this.router.navigate(['/main/crt/affiliationView'], {
      state: {
        fromResultProfile: true
      }
    });
  }, 50);
}
  getExpireDate(type: string, element: SourceCrossReference) {
    this.commonService.setShowLoader(true);
    let params = {};
    if (type === 'DEA') {
      params = {
        DEA: element.dea_num,
        rcm_id: element.rcm_id,
        source_id: element.source_id,
      };
    } else if (type === 'TDDD') {
      params = {
        TDDD: element.tddd_oh,
        rcm_id: element.rcm_id,
        source_id: element.source_id,
      };
    } else if (type === 'SLN') {
      params = {
        SLN: element.sln,
        rcm_id: element.rcm_id,
        source_id: element.source_id,
      };
    } else if (type === 'HCCE') {
      params = {
        HCCE: element.hcce,
        rcm_id: element.rcm_id,
        source_id: element.source_id,
      };
    }
    this.searchProfileService
      .getExpireDate(params)
      .subscribe({
        next: (res: SourceData) => {
          this.commonService.setShowLoader(false);
          const modalRef = this.modalService.open(SourcePopupComponent, {
            centered: true,
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
          });
          modalRef.componentInstance.sourceData = res.data;
          modalRef.componentInstance.type = type;
          modalRef.componentInstance.typeValue = element.dea_num;
        },
        error: () => {
          this.commonService.setShowLoader(false);
          this.toastr.error('Failed to fetch expiration date.');
        }
      });
  }
 resetSearch() {
  this.commonService.bsBackButton.next(this.commonService.navFrom);

  this.commonService.bulkSearchResponse.set([]);

  this.commonService.selectedResultProfileRcmId = '';
  this.commonService.selectedAffiliationProfile = null as any;

  if (this.bulkSearchService.uploadSubscription) {
    this.bulkSearchService.uploadSubscription.unsubscribe();
    this.bulkSearchService.bulkSearchStatus.set('');
  }
}

  getStandardAddress(element: SourceCrossReference) {
    this.commonService.setShowLoader(true);
    this.searchProfileService
      .getStandardAddress({
        id: element.id,
        source_id: element.source_id,
        address: element.address_line_1,
      })
      .subscribe({
        next: (res: StandardAddress) => {
          this.commonService.setShowLoader(false);
          this.standardData = res.data;
          this.modalService.open(this.modalTemplateRef, {
            centered: true,
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
          });
        },
        error: () => {
          this.commonService.setShowLoader(false);
          this.toastr.error('Failed to fetch standard address.');
        }
      });
  }
  showColumnSetting(dataSource: string) {
    const modalRef = this.modalService.open(ColumnSelectionPopupComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    });
    modalRef.componentInstance.allItems = this.columnModal;
    modalRef.componentInstance.dataSource = dataSource;
    modalRef.componentInstance.colPref = this.colPref;
    modalRef.result.then(
      () => {
        this.setDisplayColumns();
      },
      () => {
        return;
      }
    );
  }
  exportData(): void {
    if (this.goldenProfilesMp.data.length == 0) {
      this.toastr.error('No data found for export!');
      return;
    }
    let propertiesToPick: string[];

const gpPref = this.searchProfileService.gpColPref();

if (!gpPref || gpPref.trim() === '') {
  propertiesToPick = this.columnModal
    .filter(m => m.type === 'golden profile')
    .map(m => m.db_column_name);
} else {
  propertiesToPick = gpPref.split(',');
}

propertiesToPick = [
  ...new Set([...this.gpMandatoryCols, ...propertiesToPick])
];
    const filteredDataSP = this.goldenProfilesMp.data.map((item: Obj) =>
      propertiesToPick.reduce((acc, key) => {
        acc[key] = item[key];
        return acc;
      }, {} as Obj)
    );
    filteredDataSP.sort((a, b) => {
      if (a[this.sortGP.active] > b[this.sortGP.active]) {
        return 1;
      }
      if (a[this.sortGP.active] < b[this.sortGP.active]) {
        return -1;
      }
      return 0;
    });
    this.columnName = [];
    for (const dc of this.displayedColumns) {
      this.columnName.push(this.displayColName.transform(dc));
    }

    this.commonService.exportToCsv(
      filteredDataSP,
      'sanofi_profile',
      this.columnName,
      propertiesToPick
    );
    this.commonService.setShowLoader(true);
    setTimeout(() => {
      this.commonService.setShowLoader(false);
      this.toastr.success('Sanofi Profile table data exported successfully');
    }, 2000);
  }
  exportSourceCrossRefData(): void {
    if (this.sourceCrossReferencesMp.data.length == 0) {
      this.toastr.error('No data found for export!');
      return;
    }
    this.sortCR.active = 'rcm_id';
    let propertiesToPick: string[];

const crPref = this.searchProfileService.crColPref();

if (!crPref || crPref.trim() === '') {
  propertiesToPick = this.columnModal
    .filter(m => m.type === 'cross reference')
    .map(m => m.db_column_name);
} else {
  propertiesToPick = crPref.split(',');
}

propertiesToPick = [
  ...new Set([...this.crMandatoryCols, ...propertiesToPick])
];
    const filteredDataCR = this.sourceCrossReferencesMp.data.map((item: Obj) =>
      propertiesToPick.reduce((acc, key) => {
        acc[key] = item[key];
        return acc;
      }, {} as Obj)
    );
    filteredDataCR.sort((a, b) => {
      if (a[this.sortCR.active] > b[this.sortCR.active]) {
        return 1;
      }
      if (a[this.sortCR.active] < b[this.sortCR.active]) {
        return -1;
      }
      return 0;
    });
    this.columnName = [];
    for (const dc of this.sourceDisplayedColumns) {
      this.columnName.push(this.displayColName.transform(dc));
    }
    this.commonService.exportToCsv(
      filteredDataCR,
      'source_cross_reference',
      this.columnName,
      propertiesToPick
    );
    this.commonService.setShowLoader(true);
    setTimeout(() => {
      this.commonService.setShowLoader(false);
      this.toastr.success(
        'Source Cross Reference table data exported successfully'
      );
    }, 2000);
  }
  setDisplayColumns() {
    let gpColumns = this.searchProfileService.gpColPref();
    let crColumns = this.searchProfileService.crColPref();
    if (gpColumns != undefined && gpColumns != null && gpColumns != '') {
      gpColumns =
        this.searchProfileService.gpMandatoryCols.join(',') + ',' + gpColumns;
      this.displayedColumns = gpColumns.split(',');
    } else {
      this.displayedColumns = this.columnModal
        .filter((m) => m.type == 'golden profile')
        .map((m) => m.db_column_name);
    }
    if (crColumns != undefined && crColumns != null && crColumns != '') {
      crColumns =
        this.searchProfileService.crMandatoryCols.join(',') + ',' + crColumns;
      this.sourceDisplayedColumns = crColumns.split(',');
    } else {
      this.sourceDisplayedColumns = this.columnModal
        .filter((m) => m.type == 'cross reference')
        .map((m) => m.db_column_name);
    }
    this.checkHasExpiredColPref();
  }
  setDistinctSource() {
  // derive from ACTUAL DATA (not sourceList)
  this.distinctSource = [
    ...new Set(this.sourceCrossReferences.map(m => m.source))
  ];

  this.selectedSources = [
    ...new Set(
      this.filteredSourceCrossReferencesFiltered.length
        ? this.filteredSourceCrossReferencesFiltered.map(item => item.source)
        : this.distinctSource
    )
  ];
}
  // setDistinctSource() {
  //   this.distinctSource = this.sourceList.map((m) => m.source);
  //   this.selectedSources = [
  //     ...new Set(
  //       this.filteredSourceCrossReferencesFiltered.map((item) => item.source)
  //     ),
  //   ];
  // }
  selectedSources: string[] = [];
  isAllSelected(): boolean {
    return this.selectedSources.length - 1 === this.distinctSource.length;
  }
  //selectAllValue = '__all__';
  toggleAllSelection(): void {
    if (this.selectedGoldenProfile) {
      this.filteredSourceCrossReferencesFiltered =
        this.sourceCrossReferences.filter((scr: SourceCrossReference) => {
          return (
            this.selectedSources.includes(scr.source) &&
            scr.rcm_id == this.selectedGoldenProfile?.rcm_id
          );
        });
    } else {
      this.filteredSourceCrossReferencesFiltered =
        this.sourceCrossReferences.filter((scr: SourceCrossReference) => {
          return this.selectedSources.includes(scr.source);
        });
    }
    this.checkExpiredDEAExist();
    this.setUpCrossRefernce();
    this.setupSortCR();
  }
  checkExpiredDEAExist() {
    this.isDeaExpiredExist = this.filteredSourceCrossReferencesFiltered.some(
      (m) => m.source_exp_flag === 'Y'
    );
  }
 getDisplayColName(type: string, col: string): string {

  if (!this.columnModal?.length) {
    return col;
  }

  const column = this.columnModal.find(
    (m) => m.type === type && m.db_column_name === col
  );

  if (!column) {
    console.warn('Column not found:', { type, col });
  }

  return column?.ui_column_name || col;
}
  getExportExpiredData() {
    let ids: string[] = [];
    let deaIds: string[] = [];
    let slnIds: string[] = [];
    let tdddIds: string[] = [];
    let hcceIds: string[] = [];
    const commasPref=this.searchProfileService.crColPref();
    //const crColPref = this.searchProfileService.crColPref().split(',');
    let crColPref:string[]=[];
    if(commasPref.trim()==''){
      crColPref=this.columnModal.filter((m) => m.type == 'cross reference').map((m) => m.db_column_name);
    }else{
      crColPref = commasPref.split(',');
    }
    if (crColPref.includes('dea_num')) {
      deaIds = this.filteredSourceCrossReferencesFiltered.filter(f => f.dea_num != '').map(m => m.dea_num);
    }
    if (crColPref.includes('sln')) {
      slnIds = this.filteredSourceCrossReferencesFiltered.filter(f => f.sln != '').map(m => m.sln);
    }
    if (crColPref.includes('tddd_oh')) {
      tdddIds = this.filteredSourceCrossReferencesFiltered.filter(f => f.tddd_oh != '').map(m => m.tddd_oh);
    }
    if (crColPref.includes('hcce')) {
      hcceIds = this.filteredSourceCrossReferencesFiltered.filter(f => f.hcce != '').map(m => m.hcce);
    }
    ids = [...deaIds, ...slnIds, ...tdddIds, ...hcceIds];
    if (ids.length <= 0) {
      this.toastr.error("No ids found for export");
      return;
    }
    const params = {
      'ALL': ids.join(','),
    };
    this.commonService.setShowLoader(true);
    this.searchProfileService
      .getExportExpirationDate(params)
      .subscribe({
        next: (res: ExportDateResponse) => {
          const data = res.data;
          const filteredData:ExportExpireDate[]=[];
          const value = this.filteredSourceCrossReferencesFiltered.filter(f => f.dea_num != '' || f.sln != ''|| f.tddd_oh != ''|| f.hcce != '');
          for(const drow of value){
            const foundRow=data.filter(m=>(m.rcm_id==drow.rcm_id && m.source_id==drow.source_id));
            filteredData.push(...foundRow);
          }
          const columns: string[] = [];
          const keys = Object.keys(data[0]);
          for (const ckey of keys) {
            columns.push(ckey.replace(/_/g, ' ').toUpperCase());
          }
          this.commonService.exportToCsv(filteredData, 'Expire_Date', columns);
          this.commonService.setShowLoader(false);
        },
        error: () => {
          this.commonService.setShowLoader(false);
          this.toastr.error('Failed to export expiration data.');
        }
      });
  }
  checkHasExpiredColPref() {
    const cols = ['dea_num', 'sln', 'tddd_oh', 'hcce'];
    const commasPref=this.searchProfileService.crColPref();
    let pref:string[]=[];
    if(commasPref.trim()==''){
      pref=this.columnModal.filter((m) => m.type == 'cross reference').map((m) => m.db_column_name);
    }else{
      pref = commasPref.split(',');
    }
    this.hasExpPrefCol = pref.some((m) => cols.includes(m));
  }
  setBulkSearchResponse() {
    const value = this.commonService.bulkSearchResponse();
    if (Object.keys(value).length > 0) {
      if (this.selectedKey) {
        this.sourceCrossReferences = this.commonService.bulkSearchResponse().filter((m) => m.key == this.selectedKey)[0].cross_reference_results;
        this.goldenProfiles = this.commonService.bulkSearchResponse().filter((m) => m.key == this.selectedKey)[0].golden_profile_results;
        setTimeout(() => {
          this.setupSortGP();
          this.setupSortCR();
        }, 0);
      } else {
        this.sourceCrossReferences = this.commonService.bulkSearchResponse()[0].cross_reference_results;
        this.goldenProfiles = this.commonService.bulkSearchResponse()[0].golden_profile_results;
        this.selectedKey = this.commonService.bulkSearchResponse()[0].key;
      }
      this.setSearchParams();
    }
  }
  changeCriteria() {
    this.ngOnInit();
  }
  BulkExport() {
  this.toastr.success('Please wait while data is exporting...');

  const bulkData = this.commonService.bulkSearchResponse();

  if (
    bulkData[0].golden_profile_results.length <= 0 &&
    bulkData[0].cross_reference_results.length <= 0
  ) {
    this.toastr.error('No data found for export.');
    return;
  }

  /********************* GOLDEN PROFILE *********************/
  const gpHeaders: string[] = [];
  const gpColumns: string[] = [];

  let gpColPref = this.searchProfileService.gpColPref().split(',');
  const mGpCols = this.searchProfileService.gpMandatoryCols;

  if (gpColPref[0] === '') {
    gpColPref = this.columnModal
      .filter(m => m.type === 'golden profile')
      .map(m => m.db_column_name);
  }

  const allGpColPref = ['criteria', ...mGpCols, ...gpColPref];

  for (const col of allGpColPref) {
    gpColumns.push(col);
    gpHeaders.push(
      col === 'criteria'
        ? 'Criteria'
        : this.displayColName.transform(col)
    );
  }

  const finalGPData: any[] = [];

  for (const gpresult of bulkData) {
    for (const row of gpresult.golden_profile_results) {
      finalGPData.push({
        criteria: gpresult.key,
        ...row
      });
    }
  }

  exportToExcelMultipleSheets(
    [
      {
        sheetName: 'Golden Profile',
        data: finalGPData,
        columns: gpColumns,
        headers: gpHeaders
      }
    ],
    'BulkSanofiProfile'
  );

  /********************* CROSS REFERENCE *********************/
  const crHeaders: string[] = [];
  const crColumns: string[] = [];

  let crColPref = this.searchProfileService.crColPref().split(',');
  const mCrCols = this.searchProfileService.crMandatoryCols;

  if (crColPref[0] === '') {
    crColPref = this.columnModal
      .filter(m => m.type === 'cross reference')
      .map(m => m.db_column_name);
  }

  const allCrColPref = ['criteria', ...mCrCols, ...crColPref];

  for (const col of allCrColPref) {
    crColumns.push(col);
    crHeaders.push(
      col === 'criteria'
        ? 'Criteria'
        : this.displayColName.transform(col)
    );
  }

  const finalCRData: any[] = [];

  for (const crresult of bulkData) {
    for (const row of crresult.cross_reference_results) {
      finalCRData.push({
        criteria: crresult.key,
        ...row
      });
    }
  }

  exportToExcelMultipleSheets(
    [
      {
        sheetName: 'Cross Reference',
        data: finalCRData,
        columns: crColumns,
        headers: crHeaders
      }
    ],
    'BulkCrossReference'
  );
}
  setSearchParams() {
    const bsPrams = this.commonService.bulkSearchResponse().find(m => m.key == this.selectedKey)?.parameters;
    const searchParams = [];
    for (const key in bsPrams) {
      const display = this.commonService.fieldsDisplay.find((fd) => fd.id === key)?.display;
      if (display) {
        const value = bsPrams[key];
        searchParams.push({ display: display, value: value });
      }
    }
    this.searchParams = searchParams;
  }
 loadProfile(rcmId: string) {
  if (!rcmId) return;

  this.commonService.setShowLoader(true);

  this.searchProfileService.getSearchProfile({ rcm_id: rcmId })
    .subscribe({
      next: (res: any) => {

        this.commonService.setShowLoader(false);

        // 1. assign data FIRST
        this.goldenProfiles = res.golden_profile_results || [];
        this.sourceCrossReferences = res.cross_reference_results || [];

        // 2. NOW initialize tables AFTER data exists
        this.goldenProfilesMp = new MatTableDataSource(this.goldenProfiles);
        this.sourceCrossReferencesMp = new MatTableDataSource(this.sourceCrossReferences);

        this.totalItems = this.goldenProfiles.length;
        this.rTotalItems = this.sourceCrossReferences.length;

        // 3. paginator reset safely
        setTimeout(() => {
          if (this.paginator) {
            this.goldenProfilesMp.paginator = this.paginator;
          }
          if (this.rPaginator) {
            this.sourceCrossReferencesMp.paginator = this.rPaginator;
          }
        });

        // 4. UI setup AFTER data
        this.setBulkSearchResponse();
        this.setDisplayColumns();
        this.sourceList = [
  ...new Map(
    this.sourceCrossReferences.map(item => [
      item.source,
      { source: item.source, type: item.type }
    ])
  ).values()
];
        this.setDistinctSource();
        this.checkExpiredDEAExist();
        this.deferSortSetup();

      },
      error: () => {
        this.commonService.setShowLoader(false);
      }
    });
}
}
